var gsap = require('gsap'),
	common = require('../base/common'),
	emitter = require('../base/emitter');

function SliderImage($el){

	var self = this;

	self.$el = $el;
	self.$images = self.$el.find('.c-slider-image_image');
	self.containerWidth = self.$el.width();
	self.current = 0;
	self.animate = false;

	self.$images.remove();

	self.create();

	self.$timer = self.$el.find('.c-slider-image_timer');
	self.interval = null;
	self.intervalTime = 3000; // in ms
	self.$navigation = self.$el.find('.c-slider-image_arrows button');


	self.$navigation.on('click', function(e){
		e.preventDefault();

		if(self.animate) return;

		// self.stopTimer();
		if($(this).hasClass('_next'))
			self.change(true);
		else
			self.change(false);
		
		// self.startTimer();

	})

	common.$window.resize(function(){
		self.resize();
	})
	self.resize();

}

SliderImage.prototype.resize  = function(){

	var self = this;

	// self.$bigContainer.height(self.$bigContainer.find('img.current').height());
	// self.$smallContainer.height(self.$smallContainer.find('img.current').height());

}

// SliderImage.prototype.getIndex = function(){

// 	var self = this,
// 		nextIndex = self.current + 1,
// 		prevIndex = self.current - 1;

// 	if(self.current + 1 > self.$images.length - 1){
// 		nextIndex = 0;
// 	}

// 	if(self.current - 1 < 0)
// 		prevIndex = prevIndex = self.$images.length - 1;

// 	return [prevIndex, nextIndex];

// }

// SliderImage.prototype.setImage = function(){

// 	var self = this;


// 	// big container

// }

SliderImage.prototype.create = function(){

	var self = this;
	var nextIndex = 0;
	if(!self.$el.find('.c-slider-image_container').length){
		self.$bigContainer = $('<div class="c-slider-image_container" />');
		self.$el.append(self.$bigContainer);
	}else{
		self.$bigContainer = self.$el.find('.c-slider-image_container');
	}

	if(!self.$el.find('.c-slider-image_container-small').length){
		self.$smallContainer = $('<div class="c-slider-image_container-small" />');
		self.$el.append(self.$smallContainer);
	}else{
		self.$smallContainer = self.$el.find('.c-slider-image_container-small');
	}

	self.$images.each(function(){
			self.$bigContainer.append('<img src="'+$(this).attr('src')+'" style="width:'+self.$el.width()+'px">');
			self.$smallContainer.append('<img src="'+$(this).attr('src')+'" style="width:'+self.$el.width()+'px">');
	})
	self.$bigContainer.find('img').eq(0).addClass('current');
	self.$smallContainer.find('img').eq(1).addClass('current');

}

SliderImage.prototype.change = function(isNext){

	var self = this;
	
	self.animate = true;

	var nextIndex = 0;
	if(isNext){
		if(self.current == self.$images.length - 1)
			nextIndex = 0;
		else
			nextIndex = self.current + 1;
	}else{
		if(self.current == 0)
			nextIndex = self.$images.length - 1
		else 
			nextIndex = self.current - 1;
	}


	var $next;
	var $current = self.$bigContainer.find('.current');
	if(isNext){
		$next = self.$bigContainer.find('.current').next();
		if(!$next.length)
			$next = self.$bigContainer.find('img').eq(0);
	}else{
		$next = self.$bigContainer.find('.current').prev();
		if(!$next.length)
			$next = self.$bigContainer.find('img').eq(self.$images.length - 1);

	}

	TweenLite.set($next ,{x: (isNext ? -1 : 1) * self.$el.width() })
	$next.addClass('moving');

	TweenLite.to($current,0.75,{x: (isNext ? 1 : -1) * self.$el.width(), ease: Power2.easeInOut})
	TweenLite.to($next,0.75,{x: 0, ease: Power2.easeInOut, onComplete: function(){

		$current.removeAttr('style')
		$current.removeClass('current');
		$next.removeAttr('style');
		$next.removeClass('moving');
		$next.addClass('current');
		self.animate = false;

	}})


	var $next2;
	var $current2 = self.$smallContainer.find('.current');
	if(isNext){
		$next2 = self.$smallContainer.find('.current').next();
		if(!$next2.length){
			$next2 = self.$smallContainer.find('img').eq(0);
		}
	}else{
		$next2 = self.$smallContainer.find('.current').prev();
		if(!$next2.length)
			$next2 = self.$smallContainer.find('img').eq(self.$images.length - 1);

	}

	TweenLite.set($next2 ,{x: (isNext ? -1 : 1) * self.$el.find('.c-slider-image_container-small img').width() })
	$next2.addClass('moving');

	TweenLite.to($current2,0.75,{x: (isNext ? 1 : -1) * self.$el.find('.c-slider-image_container-small img').width(), ease: Power2.easeInOut})
	TweenLite.to($next2,0.75,{x: 0, ease: Power2.easeInOut, onComplete: function(){

		$current2.removeAttr('style')
		$current2.removeClass('current');
		$next2.removeAttr('style');
		$next2.removeClass('moving');
		$next2.addClass('current');

	}})


	// var $tempSlide = self.$el.find(isNext ? '.next-image' : '.prev-image');
	// var tempCurrentSlideMove = self.containerWidth;

	// var index = self.getIndex();
	// BIG IMAGE

	// var src = self.$images.eq(isNext ? index[1] : index[0]).attr('src')
	// var $currentSlide = self.$bigContainer.find('.current');
	// var $nextSlide = $('<img class="'+(isNext ? 'next-image' : 'prev-image')+'" src="'+src+'">');
	// self.$bigContainer.append($nextSlide);

	// TweenLite.fromTo($nextSlide, 0.6, {x: isNext ? -tempCurrentSlideMove : tempCurrentSlideMove },{ x: 0, onComplete: function(){

		// if(!isNext)
		// 	self.animate = false;
		// self.$bigContainer.find('.current').remove()
		// self.$bigContainer.find(isNext ? '.next-image' : '.prev-image').removeClass(isNext ? 'next-image' : 'prev-image').addClass('current');

		// if(isNext){
		// 	if(self.current + 1 > self.$images.length - 1)
		// 		self.current = 0;
		// 	else
		// 		self.current ++;
		// }else{
		// 	if(self.current - 1 < 0)
		// 		self.current = self.$images.length - 1;
		// 	else
		// 		self.current --;
		// }

	// }})

	// SMALL IMAGE
	// var newIndex;
	// if(isNext){
	// 	if(index[1] - 1 < 0 )
	// 		newIndex = self.$images.length -1;
	// 	else
	// 		newIndex = index[1] - 1;
	// }else{
	// 	if(index[0] - 1 < 0 )
	// 		newIndex = self.$images.length -1;
	// 	else
	// 		newIndex = index[0] - 1;

	// }


	// var src = self.$images.eq(newIndex).attr('src')
	// var $currentSlide = self.$smallContainer.find('.current');
	// var $nextSlide = $('<img class="'+(isNext ? 'next-image' : 'prev-image')+'" src="'+src+'">');
	// self.$smallContainer.append($nextSlide);

	// TweenLite.fromTo($nextSlide, 0.6, {x: isNext ? -tempCurrentSlideMove * 0.5 : tempCurrentSlideMove * 0.5 },{ x: 0, onComplete: function(){

	// 	if(isNext)
	// 		self.animate = false;

	// 	self.$smallContainer.find('.current').remove()
	// 	self.$smallContainer.find(isNext ? '.next-image' : '.prev-image').removeClass(isNext ? 'next-image' : 'prev-image').addClass('current');

	// }})

}

SliderImage.prototype.timerAnimation = function(){
		
	var self = this;

	self.$timer.find('circle').animate({
		'stroke-dashoffset': 0
	}, self.intervalTime, 'linear', function(){
		self.$timer.find('circle').removeAttr('style');
		self.change(true);
	})

}

SliderImage.prototype.stopTimer = function(){

	var self = this;
	if(self.interval){
		clearInterval(self.interval);
		self.$timer.find('circle').stop(true,false).removeAttr('style');
	}

}

SliderImage.prototype.startTimer = function(){

	var self = this;
	self.timerAnimation();
	self.interval = setInterval(function(){
		self.timerAnimation();
	},self.intervalTime);

}

module.exports = SliderImage;


/** WEBPACK FOOTER **
 ** ./components/slider-image.js
 **/